new WOW().init();


(function($) {


  $(document).ready(function() {

	/***************************************************/
	/* 					MENU Switch 				   */
	
	
	if(window.innerWidth > 992 ) {
		if( !$("body").hasClass("home") ) {
			$('.navbar-brand').removeClass('navbar-brand-active');
			$('.navbar-full-container').addClass('navbar-active');
		}
		$( ".navbar-switch" ).on('click', function() {
			$('.navbar-full-container').addClass('navbar-active');
			$('.navbar-brand').removeClass('navbar-brand-active');
			
		});
		$(window).scroll(function () {
			if( !$('.navbar-header').hasClass('navbar-header--black'))
				$('.navbar-header').addClass('navbar-header--black');
				
			if( !$('.navbar-full-container').hasClass('navbar-active')) {	
				if ($(document).scrollTop() > $( ".navbar-switch" ).height()/2) {
					$('.navbar-full-container').removeClass('animation-fadeout');
					$('.navbar-full-container').addClass('navbar-active animation-fadein');
					$('.navbar-brand').removeClass('navbar-brand-active');
				}
			} else { 			 
				$('.navbar-header').addClass('navbar-header--black');  
/*
				if ($(document).scrollTop() < $( ".navbar-switch" ).height()/2) {
					$('.navbar-full-container').addClass('animation-fadeout');
					$('.navbar-full-container').removeClass('navbar-active');
					$('.navbar-brand').addClass('navbar-brand-active');
				}  
*/
			}	   
		});
	} else {
		if( !$("body").hasClass("home") ) {
			$('.navbar-full-container').removeClass('navbar-active');
		}
		$( ".navbar-switch" ).on('click', function() {
			$('.navbar-full-container').toggleClass('navbar-active');
			$('main').toggleClass('menu-active');
			$('footer').toggleClass('menu-active');
			$('body').toggleClass('menu-body');
			
/*
			if( $('.navbar-full-container').hasClass('navbar-active')) {
				$('.navbar-header').addClass('navbar-header--black');
			} else if ($(document).scrollTop() < $( ".navbar-switch" ).height() && $("body").hasClass("home")){
				$('.navbar-header').removeClass('navbar-header--black');
			}
*/
		});
		$(window).scroll(function () {
			if( !$('.navbar-header').hasClass('navbar-header--black'))
				$('.navbar-header').addClass('navbar-header--black');
/*
			if( !$('.navbar-header').hasClass('navbar-header--black') && $("body").hasClass("home") ) {
				if ($(document).scrollTop() > $( ".navbar-switch" ).height()) {
					$('.navbar-header').addClass('navbar-header--black');
				}
			} else if ($("body").hasClass("home")){
				if ($(document).scrollTop() < $( ".navbar-switch" ).height()) {
					$('.navbar-header').removeClass('navbar-header--black');
				}
			}	
*/   
		});
	}
	/***************************************************/
	/* 				Scroll to contact form	      	   */
	( function() {
		$( 'a.anchor' ).on( 'click', function(e) {
		e.preventDefault();
    	var href = $(this).attr('href');
    	if( href === '#formularz') {
	    	$('.section-contact-form').show();
	    	$('.section-contact-form').addClass("animation-fadein");
	    	if($(this).data('title') != undefined && $(this).data('title') != "undefined")
	    		document.getElementById('subject').value = $(this).data('title');
	    		
    	}
   		$('html, body').animate( { 
			scrollTop: ($( href ).offset().top) - 50  + 'px'
		}, 600, function() {
    	}); 
    	location.hash = href;
  	});

	})();
        //scroll to anchor on another page
        //
        //$('html').css({display: 'none'});

        $(document).ready(function(){
            var hashURL = location.hash;
            if(hashURL != "" && hashURL.length > 1){
                $(window).scrollTop(0);
                $('html').css({display: 'block'});
                smoothScrollTo(hashURL);
            } else {
                $('html').css({display: 'block'});
            }
        });        
        
        function smoothScrollTo(anchor) {
            var targetY = $(anchor).offset().top - $( ".navbar" ).height() - 20;
            $("html, body").animate({
                "scrollTop" : targetY
            }, 600, 'swing');
        }
        //end anchor
	
	/***************************************************/
	/* 				Windswept rotation		      	   */

	var img = document.getElementById('windswept');
	if ( img != null  && window.innerWidth > 992 ) {
		var offset = img.getBoundingClientRect();
			function rotation ( evt ) {
				var center_x = (offset.left) + (offset.width/2);
				var center_y = (offset.top) + (offset.height/2);
				var mouse_x = evt.pageX; 
				var mouse_y = evt.pageY;
		
				var radians = Math.atan2(mouse_x - center_x, mouse_y - center_y);
				var degree = (radians * (180 / Math.PI) * -1) - 30 ; 
				var rot = 0;
		
				if( degree < 300 && degree > 240 ) {
					rot = 300 + (60 - (degree % 60));
				} else if ( degree < 240 && degree > 180 ) {
					rot = 0 + (60-(degree % 60));
				} else if ( degree < 180 && degree > 120 ){
					rot = 360  - (degree % 60);
				} else if ( degree < 120 && degree > 60 ){
					rot = 60  - (degree % 60);
				} else {
					rot = degree;
				}
		
				var def = "rotate(" + rot + "deg)";
				img.style.transform = def;
			}
		document.addEventListener('mousemove', rotation);
	};


	/***************************************************/
	/*    	WP_AJAX load more post, pagination   	   */


	var page = 2;
	jQuery(function($) {
		$('body').on('click', '#loadmore', function() {
			var data = {
				'action': 'load_posts_by_ajax',
				'page': page,
			};
			$.post(v.ajaxurl, data, function(response) {
				for(var i = 0; i < response.length; i++) {
					/************************************/
					/* 
					/* SAME AS BELOW, BUT WRITEN IN Template literals
					/* easier in edit, simplyfi with babeljs.io
					/*
					/************************************
					var post = `				
						<div class="col-xl-3 col-sm-4 news" style="margin-bottom: 120px;">
							<div class="box-news">
								<a href="` + response[i]["link"] + `">
									<div class="image news-image">
										<img class="img-responsive" src="` + response[i]["img"] + `" alt="">
									</div>
									<div class="content news-content">
										<h3 class="title news-title">` + response[i]["title"] + `</h3>
										<div class="news-short">` + response[i]["excerpt"] + `</div>
									</div>
									<span class="news-arrow arrow-foward" aria-hidden="true"></span>
								</a>
							</div>
						</div>`;
					*/
					/************************************/
					var post = "\t\t\t\t\n\t<div class=\"col-xl-3 col-sm-4 news\" style=\"margin-bottom: 120px;\">\n\t\t<div class=\"box-news\">\n        \t<a href=\"" + response[i]["link"] + "\">\n            \t<div class=\"image news-image\">\n\t\t\t\t\t<img class=\"img-responsive\" src=\"" + response[i]["img"] + "\" alt=\"\">\n\t\t\t\t</div>\n\t\t\t\t<div class=\"content news-content\">\n\t\t\t\t\t<h3 class=\"title news-title\">" + response[i]["title"] + "</h3>\n\t\t\t\t\t<div class=\"news-short\">" + response[i]["excerpt"] + "</div>\n\t\t\t\t</div>\n\t\t\t\t<span class=\"news-arrow arrow-foward\" aria-hidden=\"true\"></span>\n\t\t\t</a>\n\t\t</div>\n\t</div>";
					$(".posts").append(post);
				}
				$(".posts").append("<div class=\"clearfix\"></div>");
				page++;
			});
		});	
	});
	


	/***************************************************/
	/* 				other					      	   */


		var subject = document.getElementById('subject');
		var clientName = document.getElementById('name');
		var contact = document.getElementById('contact');
		var content = document.getElementById('content');
		
		
		//if(subject.value == "") subject.classList.add("gray");
		if(clientName !== null && clientName.value == "") clientName.classList.add("gray");
		if(contact !== null && contact.value == "") contact.classList.add("gray");
		if(content !== null && content.value == "") content.classList.add("gray");
		
		
		
		if( clientName !== null && contact !== null && content !== null ) {
			clientName.addEventListener('input', function(){
				if(clientName.value !== "") {
					clientName.classList.remove("gray");
				}
			})
			contact.addEventListener('input', function(){
				if(contact.value !== "") {
					contact.classList.remove("gray");
				}
			})
			
			content.addEventListener('input', function(){
				if(content.value !== "") {
					content.classList.remove("gray");
				}
			})
		}
		
		
  		 var kdnumber = function(e) {
		   // Allow: backspace, delete, tab, escape, enter, ctrl+A and .
		// Allow: backspace, tab, delete, escape, comma, and enter
        if (event.keyCode == 8 || event.keyCode == 9 || event.keyCode == 46 || event.keyCode == 27 || event.keyCode == 188 || event.keyCode == 13 ||
        // Allow: Ctrl+A
        (event.keyCode == 65 && event.ctrlKey === true) ||
        // Allow: home, end, left, right
        (event.keyCode >= 35 && event.keyCode <= 39)) {
            // let it happen, don't do anything
            return;
        }
        else {
            // Ensure that it is a number and stop the keypress
            if (event.shiftKey || (event.keyCode < 96 || event.keyCode > 105) && (event.keyCode < 48 || event.keyCode > 57) ) {
                event.preventDefault();
            }
        }
		};
	
		
		$('#form_client_id').attr({
			type : 'text',
			maxlength : 5,
			pattern : "[0-9]"
		}).on('keydown', kdnumber);
		
		
		
		$('#form_nip').attr({
			type : 'text',
			
			maxlength : 10,
			pattern: "^((\d{3}[- ]\d{3}[- ]\d{2}[- ]\d{2})|(\d{3}[- ]\d{2}[- ]\d{2}[- ]\d{3}))$"
		}).on('keydown', kdnumber);

		
		$('#form_tel').attr({
			type : 'text',
			maxlength : 9,
			pattern : "[0-9]"
		}).on('keydown', kdnumber);
		
		$('#form_home_number').attr({
			type : 'text',
			maxlength : 4,
			pattern : "[0-9]"
		}).on('keydown', kdnumber);
		
		$('#form_home_number2').attr({
			type : 'text',
			maxlength : 4,
			pattern : "[0-9]"
		}).on('keydown', kdnumber);
		
		$('#form_kod').attr({
			type : 'text',
			maxlength : 6,
			pattern : "[0-9]{2}\-[0-9]{3}$"
		}).on('keydown', kdnumber);
		

		var ef = $("#menu-item-1643 a").html();
		$("#menu-item-1643 a").html("<span class='ef-nav'>"+ef+"</span>");
		
	 
        $('img.svg').each(function(){
            var $img = jQuery(this);
            var imgID = $img.attr('id');
            var imgClass = $img.attr('class');
            var imgURL = $img.attr('src');

            $.get(imgURL, function(data) {
                // Get the SVG tag, ignore the rest
                
                               
                var $svg = jQuery(data).find('svg');
				$svg = $svg.remove('style');
                
//                 console.log( $svg );
                

                // Add replaced image's ID to the new SVG
                if(typeof imgID !== 'undefined') {
                    $svg = $svg.attr('id', imgID);
                }
                // Add replaced image's classes to the new SVG
                if(typeof imgClass !== 'undefined') {
                    $svg = $svg.attr('class', imgClass+' replaced-svg');
                }

                // Remove any invalid XML tags as per http://validator.w3.org
                $svg = $svg.removeAttr('xmlns:a');
               

                // Replace image with new SVG
                $img.replaceWith($svg);

            }, 'xml');
        }); // img.svg
        
        
        $('.single-job #career-subject').val( 'Ogłoszenie: ' + $('.type-job h1').text() );


		if( $( window ).width() < 767 ) {

	        $('.dropdown > a').attr({
		        'href': '#',
		        'data-toggle': 'dropdown'
	        });
        
        }

		
		
		$('.tab-content a[href$=".jpg"]').click(function (event) {
			event.preventDefault();
			
			var $this = $( this );
			
			var url = $this.attr('href');
			lity( url );
			
		});


		$('.scroll-top').click(function(event) {
			event.preventDefault();
			
			
			var body = $("html, body");
			body.stop().animate({
				scrollTop: 0
			}, 500, 'swing');
			
			
			return false;
		});
		
		$('.scroll-down').bind('click', function(event) {
			var $anchor = $(this);
			$('html, body').stop().animate({
            	scrollTop: $($anchor.attr('href')).offset().top
        		}, 500, 'swing');
				event.preventDefault();
    	}); 
		
		
		lightbox.option({
		  'albumLabel':  "%1/%2"
		});
		
		
		
		
		// $('#newsletter').submit(function (event) {
		// 	event.preventDefault();
			
		// 	var data = $( this ).serialize();
			
		// 	$.post( v.ajaxurl, data, function (data) {
		// 		var info = $('#newsletter_modal');
				
		// 		if( data.status ) {
		// 			info.find('.title').text('Dziękujemy!');
		// 			info.find('.text').text('Pomyślnie zapisałeś się do newslettera Scandagra Polska.');
		// 		} else {
		// 			if( data.code == 1304 )	{
		// 				info.find('.title').text('Błąd');
		// 				info.find('.text').text('Podany e-mail występuje juz bazie');
		// 			}
		// 			else {
		// 				info.find('.title').text('Błąd');
		// 				info.find('.text').text('Wystąpił błąd, prosimy spróbować poźniej');
		// 			}
		// 		}
				
		// 		info.modal('show');
		// 	});
			
		// });
        

  });
  

	
	


})(jQuery);



	/***************************************************/
	/* 				FLEXSLIDER Init			      	   */


var Slider = (function($)
{
	var _public = {
		
		slider: function()
		{
			$('.slider-section').flexslider({
				controlNav: false,
				directionNav: true, 
				pauseOnAction: false,
				start: function(){ // Fires when the slider loads the first slide
					$('.slide-infobox').addClass('animation-slide-loaded');
				},
				before: function(){ // Fires asynchronously with each slider animation
					$('.slide-infobox').removeClass('animation-slide-loaded');
				},
				after: function(){ // Fires after each slider animation completes
					$('.slide-infobox').addClass('animation-slide-loaded');

				} 
			});
			
			$('.slider-journal').flexslider({
				controlNav: false,
				directionNav: true, 
				pauseOnAction: true,
				slideshowSpeed: 3000
			});
			
			$('.invest-gallery').flexslider({
				controlNav: false,
				directionNav: true,  
				animation: "slide", 
				start: function(){
					$("#currentSlide").text( $(".flex-active-slide").data("item") );
				},
				after: function(){
					$("#currentSlide").text( $(".flex-active-slide").data("item") );
				}
			});
			
			$('.text-slider').flexslider({
				controlNav: true,
				directionNav: false,
				smoothHeight: true,
				prevText: '',
				nextText: '',
			});
			
			$('.product-slider').flexslider({

				directionNav: false,
				manualControls: ".product-thumbnails li",
				slideshow: true,
// 				smoothHeight: true,
			});
		},
		
		init: function()
		{
			$( document ).ready( _public.slider );
		}
	}
	
	
	return _public;
}(jQuery)).init();


